import { css } from 'styled-components';
export const figure = _ref => {
  let {
    $heightSize,
    $responsive,
    $fit
  } = _ref;
  return css(["position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:100%;line-height:0;img{max-height:", ";max-width:100%;object-fit:", ";", " ", "}"], $heightSize, $fit ? 'cover' : 'contain', $fit ? `
     height: 100%;
     width: 100%;
   ` : '', $responsive ? 'width: 100%;' : '');
};
export const frame = _ref2 => {
  let {
    width,
    height
  } = _ref2;
  return css(["position:relative;display:flex;align-items:center;justify-content:center;", ";", ";"], width ? `width: ${width}` : '', height ? `height: ${height}` : '');
};
//# sourceMappingURL=Image.style.js.map